// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AH0X","label":"styles_label__ewdl8"};